var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Vehicle_Request"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Request",
    "data-name": "Vehicle Request",
    clipPath: "url(#clip-Vehicle_Request)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7323",
    "data-name": "Rectangle 7323",
    width: 27,
    height: 26.995,
    rx: 6,
    transform: "translate(0.5 0.502)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8589",
    "data-name": "Group 8589",
    transform: "translate(6 6.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18577",
    "data-name": "Path 18577",
    d: "M341.882,340.04a1.03,1.03,0,1,0,1.019,1.037A1.04,1.04,0,0,0,341.882,340.04Z",
    transform: "translate(-328.386 -330.232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18578",
    "data-name": "Path 18578",
    d: "M124.662,340.042a1.03,1.03,0,1,0,1.028,1.028A1.039,1.039,0,0,0,124.662,340.042Z",
    transform: "translate(-120.528 -330.234)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18579",
    "data-name": "Path 18579",
    d: "M75.686,293.691c0,.04,0,.08,0,.12a.515.515,0,0,0,.52.491c.206.006.413-.006.618,0a.288.288,0,0,0,.255-.127,2.05,2.05,0,0,1,3.391-.01.277.277,0,0,0,.264.137c1.369,0,2.738,0,4.106,0h.182v-2.056H75.686C75.686,292.741,75.686,293.216,75.686,293.691Z",
    transform: "translate(-74.646 -284.494)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18580",
    "data-name": "Path 18580",
    d: "M367.693,175.235q-.486-.974-.973-1.948a1.586,1.586,0,0,0-1.7-.949v3.077h2.752C367.744,175.345,367.72,175.289,367.693,175.235Z",
    transform: "translate(-351.527 -169.743)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18581",
    "data-name": "Path 18581",
    d: "M321.8,178.636a.518.518,0,1,1,0-1.031c.152,0,.3,0,.456,0v-1.032h-3.509a.533.533,0,0,1-.608-.612q0-1.658,0-3.317v-.191h-1.02v7.2a.285.285,0,0,0,.388-.164.423.423,0,0,1,.073-.1,2.057,2.057,0,0,1,3.307.163.26.26,0,0,0,.17.106c.234.012.469.01.7,0a.493.493,0,0,0,.491-.423,5.365,5.365,0,0,0,0-.606C322.1,178.637,321.949,178.638,321.8,178.636Z",
    transform: "translate(-305.685 -169.861)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18582",
    "data-name": "Path 18582",
    d: "M75.686,293.691c0,.04,0,.08,0,.12a.515.515,0,0,0,.52.491c.206.006.413-.006.618,0a.288.288,0,0,0,.255-.127,2.05,2.05,0,0,1,3.391-.01.277.277,0,0,0,.264.137c1.369,0,2.738,0,4.106,0h.182v-2.056H75.686C75.686,292.741,75.686,293.216,75.686,293.691Z",
    transform: "translate(-74.646 -284.494)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18583",
    "data-name": "Path 18583",
    d: "M84.42,124.359H76.31c-.435,0-.624.191-.624.631q0,2.681,0,5.362v.19h9.352v-.183q0-2.69,0-5.379C85.038,124.552,84.845,124.359,84.42,124.359Z",
    transform: "translate(-74.647 -123.836)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18584",
    "data-name": "Path 18584",
    d: "M124.662,340.042a1.03,1.03,0,1,0,1.028,1.028A1.039,1.039,0,0,0,124.662,340.042Z",
    transform: "translate(-120.528 -330.234)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18585",
    "data-name": "Path 18585",
    d: "M321.8,178.636a.518.518,0,1,1,0-1.031c.152,0,.3,0,.456,0v-1.032h-3.509a.533.533,0,0,1-.608-.612q0-1.658,0-3.317v-.191h-1.02v7.2a.285.285,0,0,0,.388-.164.423.423,0,0,1,.073-.1,2.057,2.057,0,0,1,3.307.163.26.26,0,0,0,.17.106c.234.012.469.01.7,0a.493.493,0,0,0,.491-.423,5.365,5.365,0,0,0,0-.606C322.1,178.637,321.949,178.638,321.8,178.636Z",
    transform: "translate(-305.685 -169.861)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18586",
    "data-name": "Path 18586",
    d: "M367.693,175.235q-.486-.974-.973-1.948a1.586,1.586,0,0,0-1.7-.949v3.077h2.752C367.744,175.345,367.72,175.289,367.693,175.235Z",
    transform: "translate(-351.527 -169.743)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18587",
    "data-name": "Path 18587",
    d: "M341.882,340.04a1.03,1.03,0,1,0,1.019,1.037A1.04,1.04,0,0,0,341.882,340.04Z",
    transform: "translate(-328.386 -330.232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8523",
    "data-name": "Group 8523",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18588",
    "data-name": "Path 18588",
    d: "M317.12,172.455h1.02v.191q0,1.658,0,3.317a.533.533,0,0,0,.608.612h3.509v1.032c-.151,0-.3,0-.456,0a.518.518,0,1,0,0,1.031c.148,0,.3,0,.456,0a5.365,5.365,0,0,1,0,.606.493.493,0,0,1-.491.423c-.235.008-.47.01-.7,0a.26.26,0,0,1-.17-.106,2.057,2.057,0,0,0-3.307-.163.423.423,0,0,0-.073.1.285.285,0,0,1-.388.164Z",
    transform: "translate(-305.686 -167.691)",
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18589",
    "data-name": "Path 18589",
    d: "M75.686,292.247h9.339V294.3h-.182c-1.369,0-2.738,0-4.106,0a.277.277,0,0,1-.264-.137,2.05,2.05,0,0,0-3.382,0,.266.266,0,0,1-.263.139c-.206-.011-.412,0-.618,0a.515.515,0,0,1-.52-.491c0-.04,0-.08,0-.12C75.686,293.216,75.686,292.741,75.686,292.247Z",
    transform: "translate(-74.644 -282.325)",
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18590",
    "data-name": "Path 18590",
    d: "M365.023,172.338a1.586,1.586,0,0,1,1.7.949q.487.973.973,1.948c.027.054.05.11.082.18h-2.752Z",
    transform: "translate(-351.527 -167.573)",
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18591",
    "data-name": "Path 18591",
    d: "M124.667,342.1a1.03,1.03,0,1,1,1.023-1.033A1.039,1.039,0,0,1,124.667,342.1Z",
    transform: "translate(-120.526 -328.064)",
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18592",
    "data-name": "Path 18592",
    d: "M342.9,341.077a1.03,1.03,0,1,1-1.019-1.037A1.039,1.039,0,0,1,342.9,341.077Z",
    transform: "translate(-328.385 -328.062)",
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7295",
    "data-name": "Rectangle 7295",
    d: "M1,0H9.86a1,1,0,0,1,1,1V8.623a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z",
    transform: "translate(0.364 0.642)",
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18593",
    "data-name": "Path 18593",
    d: "M69.1,106.578c-.492-.988-1.025-1.978-1.519-2.966a2.574,2.574,0,0,0-2.469-1.52H62.91l-.011-1.66s0-.321,0-.47a1.546,1.546,0,0,0-1.584-1.591q-4.125-.009-8.251,0a1.534,1.534,0,0,0-.961.315A1.566,1.566,0,0,0,51.484,100c0,1.312,0,4.285,0,5.6s.032,2.637-.01,3.954a1.636,1.636,0,0,0,1.827,1.826c.078-.006.157,0,.234,0a2.088,2.088,0,0,0,1.961,2.059,2.01,2.01,0,0,0,1.364-.423,2.073,2.073,0,0,0,.818-1.625h5.214a2.08,2.08,0,0,0,1.893,2.044,1.978,1.978,0,0,0,1.335-.351,2.083,2.083,0,0,0,.912-1.7c.172,0,.326,0,.48,0a1.47,1.47,0,0,0,1.264-.641,1.351,1.351,0,0,0,.143-.326,3.579,3.579,0,0,0,.168-1.094S69.109,106.587,69.1,106.578Zm-7.237.666H52.516v-.19c0-1.787,0-5.235,0-7.022,0-.44.189-.631.624-.631h8.11c.425,0,.617.193.617.62,0,1.793,0,5.246,0,7.039Zm-6.25,5.164a1.03,1.03,0,1,1,1.023-1.033A1.039,1.039,0,0,1,55.617,112.408Zm6.238-2.062h-.182c-1.369,0-2.738,0-4.106,0a.277.277,0,0,1-.264-.137,2.05,2.05,0,0,0-3.391.01.288.288,0,0,1-.255.127c-.206-.011-.412,0-.618,0a.515.515,0,0,1-.52-.491c0-.04,0-.08,0-.12,0-.475,0-.95,0-1.444h9.339Zm3.118-7.212a1.586,1.586,0,0,1,1.7.949q.487.973.973,1.948c.027.054.05.11.082.18H64.972Zm-.013,9.274a1.03,1.03,0,1,1,1.033-1.023A1.04,1.04,0,0,1,64.959,112.408Zm3.084-2.487a.493.493,0,0,1-.491.423c-.235.008-.47.009-.7,0a.26.26,0,0,1-.17-.106,2.057,2.057,0,0,0-3.307-.163.421.421,0,0,0-.072.1.285.285,0,0,1-.388.164v-7.2h1.02v.191q0,1.658,0,3.317a.533.533,0,0,0,.608.612h3.509v1.032c-.151,0-.3,0-.455,0a.518.518,0,1,0,0,1.031c.148,0,.3,0,.456,0A5.372,5.372,0,0,1,68.043,109.92Z",
    transform: "translate(-51.473 -98.368)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleRequest);
export default __webpack_public_path__ + "static/media/Vehicle Request.644fb87e4b581bd699d51ee3f1376094.svg";
export { ForwardRef as ReactComponent };